import React, { useEffect } from "react";
import { Box, Button, FormHelperText, Grid, OutlinedInput, TextField, Typography } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';

export interface DefaultUploadFileProps {
    setFileUpload: (file: File | null) => void,
    file: File | undefined | null,
    extensions?: string[],
    maxFileSizeMb?: number,
    id: string,
    error?: boolean,
    disabled?: boolean,
    existingImageUrl?: string,
}

export default function DefaultUploadFile(props: DefaultUploadFileProps) {
    const [selectedFile, setSelectedFile] = React.useState<File | undefined | null>(props.file);
    const [errorFile, setErrorFile] = React.useState<string>();
    const handleChange = (selectedFile: FileList) => {
        setErrorFile(undefined);
        if (selectedFile != null && selectedFile.length > 0) {
            var file = selectedFile[0];

            if (validateFile(file)) {
                setSelectedFile(file);
                if (props.setFileUpload !== undefined && props.setFileUpload !== null) {
                    console.log("setFileUpload");
                    props.setFileUpload(file);
                }
            }
        }
    };
    const validateFile = (file: File) => {
        if (props.maxFileSizeMb !== undefined) {
            var maxFileSizeBytes = props.maxFileSizeMb * 1024 * 1024;
            if (file.size > maxFileSizeBytes) {
                setErrorFile(`O arquivo deve ter no máximo ${props.maxFileSizeMb} MB`);
                return false
            }
        }
        if (props.extensions !== undefined) {
            var ext = file.name.split('.').pop()?.toLowerCase();
            if (ext !== undefined && !props.extensions.includes(ext)) {
                setErrorFile(`O arquivo deve ter uma das seguintes extensões: ${props.extensions.join(", ")}`);
                return false
            }
        }
        return true
    };
    useEffect(() => {
        setSelectedFile(props.file);
    }, [props.file]);
    return (
        <React.Fragment>

            <input
                style={{ display: 'none' }}
                id={props.id}
                multiple={false}
                type="file"
                onChange={(e: any) => handleChange(e.target.files)}
                disabled={props.disabled}
            />
            <label htmlFor={props.id}>

                <OutlinedInput
                    name={`input-file-${props.id}`}
                    fullWidth
                    readOnly={true}
                          size="small"
                    error={props.error !== undefined ? props.error : errorFile !== undefined}
                    value={selectedFile?.name !== undefined ? selectedFile?.name : ""}
                    disabled={props.disabled}

                    endAdornment={
                        <Button
                            variant="contained"
                            sx={{ pr: 3, pl: 3 }}
                            component="span"
                            endIcon={<AttachFileIcon />}
                            disabled={props.disabled}
                        >
                            Selecionar
                        </Button>
                    }
                />
                {errorFile && (
                    <FormHelperText error>
                        {errorFile}
                    </FormHelperText>
                )}
            </label>

            {!selectedFile && props.existingImageUrl && (
                <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box
                        component="img"
                        src={props.existingImageUrl}
                        alt="Imagem atual"
                        sx={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 1, border: '1px solid #ddd' }}
                    />
                    <Typography variant="caption" color="textSecondary">
                        Imagem atual — selecione um novo arquivo para substituir
                    </Typography>
                </Box>
            )}

        </React.Fragment>

    );
}